import { computed } from 'vue'
import { toValue } from 'vue'

/**
 * Utility function to generate tabindex and aria-disabled attributes based on a disabled or readonly state.
 * @param {import('vue').MaybeRefOrGetter<boolean>} disabledOrReadonly
 * @returns {import('vue').ComputedRef<{ tabindex: number, 'aria-disabled': boolean } | {}>} Computed ref containing the appropriate attributes.
 */
export const useTabindexAttrs = disabledOrReadonly => {
  return computed(() => {
    if (toValue(disabledOrReadonly)) {
      return {
        tabindex: -1,
        'aria-disabled': true
      }
    }
    return {}
  })
}
